import toast from "react-hot-toast";
import { getApiErrorLines } from "./formErrors";
import { toPersianDigits } from "./numberFormat";

const MAX_TOAST_LINES = 6;

// No `id` here: toast.promise reuses its loading toast's id, and an id in
// these options would override it and leave the spinner on screen.
export const ERROR_TOAST_OPTIONS = {
  duration: 8000,
  style: {
    whiteSpace: "pre-line",
    direction: "rtl",
    textAlign: "right",
    fontFamily: "Vazirmatn, sans-serif",
    maxWidth: 520,
  },
};

export function formatErrorLines(lines) {
  const list = (Array.isArray(lines) ? lines : [lines]).filter(Boolean);
  if (list.length <= 1) return list[0] || "";
  const shown = list.slice(0, MAX_TOAST_LINES).map((line) => `• ${line}`);
  if (list.length > MAX_TOAST_LINES) {
    shown.push(`و ${toPersianDigits(list.length - MAX_TOAST_LINES)} مورد دیگر`);
  }
  return ["لطفاً موارد زیر را اصلاح کنید:", ...shown].join("\n");
}

/** Shows one or more Persian error lines in a single toast. */
export function toastErrors(lines) {
  // A fixed id makes a new submit replace the previous error toast.
  return toast.error(formatErrorLines(lines), { ...ERROR_TOAST_OPTIONS, id: "form-errors" });
}

/** Shows an API error (validation, status or network) as a Persian toast. */
export function toastApiError(error, labels, fallback) {
  return toastErrors(getApiErrorLines(error, labels, fallback));
}

/** Lists labels of required fields that are empty, as "Label: الزامی است." */
export function missingRequired(values, labels) {
  return Object.entries(labels)
    .filter(([name]) => String(values?.[name] ?? "").trim() === "")
    .map(([, label]) => `${label}: الزامی است.`);
}
